import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../../../../../components/ButtonRounded";
import EditableTableContainer from "../../../../../../containers/sustainability/allocation/roadUse/EditableTable";
import MatchingTables from "../../../../../../containers/sustainability/allocation/roadUse/MatchingTables";
import {Typography} from "@material-ui/core";
import { postStepBiotemplatesData, putStepOverViewData } from "../../../../../../api/sustainability/allocation/roadUse/stepData";
import setAllocationRequirement from "../../../../../../api/sustainability/allocationSteps/setAllocationRequirement";
import RoadUseCustomerRequirements from "./RoadUseCustomerRequirements";
import SuccessView from "./SuccessView";
import { ReactReduxContext, useDispatch } from "react-redux";
import api_setAllocateCustomer from "../../../../../../api/sustainability/allocationSteps/setAllocateCustomer";
import {postSetActiveStep} from "../../../../../../api/sustainability/allocation/roadUse/stepData";
import {
    updateBiotemplateStepFive, updateBiotemplateStepFour, updateBiotemplateStepThree, updateBiotemplateStepJointFulf,
    updateBiotemplateStepTwo, updateBiotemplateStepSurplusVol
} from "../../../../../../reducers/sustainability/allocation/roaduseAllocation";
import parseToFloat from "../../../../../../components/texts/parseToFloat";
import { useMainCardStyles } from "../../../../../../common/styles/cardStyles";

const useStyles = useMainCardStyles;

interface RoadUseCardEditableTableProps {
  step: number;
  reqByCustomerDisabled: boolean;
  outJointDisabled: boolean;
  aboveMandateAfterFulfillDisabled: boolean;
  surplusStepDisabled: boolean;
  handleNext: () => void;
  handleBack: () => void;
  updateIsFetching: (value: boolean) => void;
  availableVol: any;
  stepTwoData: any[];
  stepThreeData: any[];
  stepFourData: any[];
  stepJointFulfData: any[];
  stepFiveData: any[];
  surplusBiotemplates: any[];
  requirementPercentages: any;
}

interface Biotemplate {
    id: number;
    biofuel_type: string;
    raw_material_origin: string;
    fuel_type: string;
    raw_material: string;
    double_counted_norway: string;
    reduction_in_climate_emission: number;
    storage_terminal: string;
    available_quantity: number;
    allocated_quantity: number;
    allocated_eq_quantity: number;
}

interface Requirement {
    surplus_from_offroad: any;
    sub_requirement_advanced_biofuels: any;
    general_requirement: any;
    reserved_quantity: any;
    joint_fulfillment_out: any;
    remaining_quantity: any;
}

interface UpdatedDataProps {
    biotemplates?: any[];
    overview?: any[];
    id?: number;
}

const RoadUseCardEditableTable: React.FC<RoadUseCardEditableTableProps> = ({
  step,
  reqByCustomerDisabled,
  outJointDisabled,
  aboveMandateAfterFulfillDisabled,
  surplusStepDisabled,
  handleBack,
  handleNext,
  updateIsFetching,
  availableVol,
  stepTwoData,
  stepThreeData,
  stepFourData,
  stepJointFulfData,
  stepFiveData,
  surplusBiotemplates,
  requirementPercentages
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isOverAllocated, setIsOverAllocated] = useState(false);
  const [updatedData, setUpdatedData] = useState<any[]>([]);
  const [updatedCustomerData, setUpdatedCustomerData] = useState([]);
  const [requirementData, setRequirementData] = useState<Requirement>({
        surplus_from_offroad: {},
        sub_requirement_advanced_biofuels: {},
        general_requirement: {},
        reserved_quantity: {},
        joint_fulfillment_out: {},
        remaining_quantity: {}
    });
  const handleTableDataUpdate = (updatedData: UpdatedDataProps, type: string) => {
        if (type === "bio") {
            setUpdatedData(prevData => ({
                ...prevData,
                // @ts-ignore
                biotemplates: updatedData.biotemplates,
            }));
        } else {
            setUpdatedData(prevData => ({
                ...prevData,
                // @ts-ignore
                overview: updatedData.overview,
                id: updatedData.id,
            }));
        }

        if (step < 7 && updatedData.biotemplates) {
          setIsOverAllocated(updatedData.biotemplates.some(
              (item: { allocated_quantity: string; available_quantity: number }) =>
                  parseToFloat(item.allocated_quantity) > parseToFloat(item.available_quantity)
          ));
        }
  };

  const handleCustomerDataUpdate = (updatedCustomerData: any[]) => {
        // @ts-ignore
        setUpdatedCustomerData(updatedCustomerData);
    };

  const handleRequirementDataUpdate = (requirementData: Requirement) => {
        // @ts-ignore
        setRequirementData(requirementData);
    };

  const clickBack = () => {
        handleBack();
    };

  const clickNext = async () => {

    if (step < 7) {
      const biotemplateUpdatedData = {
        // @ts-ignore
        biotemplates : updatedData.biotemplates,
      };

      updateIsFetching(true);
      if (step === 0) {
      }
      if (step === 1) {
        dispatch(updateBiotemplateStepSurplusVol(biotemplateUpdatedData.biotemplates));
      }
      if (step === 2) {
        dispatch(updateBiotemplateStepTwo(biotemplateUpdatedData.biotemplates));
      }
      if (step === 3) {
        dispatch(updateBiotemplateStepThree(biotemplateUpdatedData.biotemplates));
      }
      if (step === 4) {
        dispatch(updateBiotemplateStepFour(biotemplateUpdatedData.biotemplates));
      }
      if (step === 5) {
        dispatch(updateBiotemplateStepJointFulf(biotemplateUpdatedData.biotemplates));
      }
      if (step === 6) {
        dispatch(updateBiotemplateStepFive(biotemplateUpdatedData.biotemplates));
      }

      const [setActiveStep, response] = await Promise.all([
        postSetActiveStep(step + 1),
        postStepBiotemplatesData(step, biotemplateUpdatedData)
      ]);

      if (response && response.success) {
        let shouldCallHandleNext = false;

        const apiCalls = [];

        if (step <= 6) {
            // @ts-ignore
            apiCalls.push(
                setAllocationRequirement(
                    requirementData.surplus_from_offroad,
                    requirementData.sub_requirement_advanced_biofuels,
                    requirementData.general_requirement,
                    requirementData.reserved_quantity,
                    requirementData.joint_fulfillment_out,
                    requirementData.remaining_quantity
                )
            );
        }

        if (step !== 6) {
            // @ts-ignore
            const overviewData = { ...updatedData.overview };
            // @ts-ignore
            overviewData.id = updatedData.id;
            apiCalls.push(putStepOverViewData(step, overviewData));
        }

        // Execute remaining API calls in parallel
        if (apiCalls.length > 0) {
            const results = await Promise.all(apiCalls);

            // Check requirement response if it was called
            if (step <= 6) {
                const reqSetResponse = results[0];
                if (reqSetResponse && reqSetResponse.valid) {
                    shouldCallHandleNext = true;
                } else {
                    alert("Some error occurred");
                    updateIsFetching(false);
                    return;
                }
            }

            if (step > 6) {
                shouldCallHandleNext = true;
            }
        }

        if (shouldCallHandleNext) {
            handleNext();
        }
        updateIsFetching(false);
      } else {
        updateIsFetching(false);
        alert("Some error occurred");
      }
    } else {
      if (step > 6 && step < 10) {
        await postSetActiveStep(step + 1);
      }
      if (step === 8) {
        updateIsFetching(true);
        const getCustomerReqAllocated = () => {
            // @ts-ignore
            const allocated_sorted = updatedCustomerData.allocated_sorted;
            let allocated: any = {};
            if (allocated_sorted && Object.keys(allocated_sorted).length > 0) {
                Object.keys(allocated_sorted).map((cust_id, cust_idx) => {
                    Object.keys(allocated_sorted[cust_id]).map((an_id, an_idx) => {
                        allocated = {
                            ...allocated,
                            [an_id]: {
                                ...allocated_sorted[cust_id][an_id],
                            },
                        };
                    });
                });
            }
            return allocated;
        };
        const apiAllocated = getCustomerReqAllocated();
        try {
            const response = await api_setAllocateCustomer(apiAllocated);
            if (response.valid) {
                updateIsFetching(false);
                handleNext();
            } else {
                updateIsFetching(false);
                alert("Some error occured when submitting data.");
            }
        } catch (error) {
            updateIsFetching(false);
            alert("Some error occured when submitting data.");
        }
      } else {
        handleNext();
      }
    }
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
                <Grid
                  container
                  alignItems="flex-start"
                  justify="space-between"
                  wrap="nowrap"
                >
                    <Grid item xs>
                          {step === 1 && (
                              <>
                                  <Typography variant="h4">Volume flexibility IN from off-road mandate surplus</Typography>
                                  <Typography variant="body2" >
                                      In this step you will specify the volume from the off-road mandate surplus to be used as volume flexibility IN for the road use mandate fulfillment. You cannot use more than the total off-road mandate surplus.
                                  </Typography>
                                  <br /><br />
                                  {surplusStepDisabled && (
                                      <Typography variant="h5">
                                          This step is disabled as no volume flexibility IN from off-road has been registered at the start page
                                      </Typography>
                                  )}
                              </>
                          )}
                          {step === 2 && (
                              <>
                                  <Typography variant="h4">Allocation of advanced sub-mandate ({requirementPercentages.advanced}%) for road use volumes</Typography>
                                  <Typography variant="body2" >
                                      In this step you will allocate the sustainability criteria for the required minimum volumes of advanced biocomponents (both gasoline and diesel) to fulfill the advanced sub-requirement to the road use mandate. If additional advanced volumes are supplied to the market, this will be allocated in step 4 (all other volumes).
                                  </Typography>
                                  <br /><br />
                              </>
                          )}
                          {step === 3 && (
                              <>
                                  <Typography variant="h4">Allocation of general mandate ({requirementPercentages.general}%) for road use volumes</Typography>
                                  <Typography variant="body2" >
                                      In this step you will allocate the sustainability criteria for the required volumes (both gasoline and diesel) to fulfill the general requirement to the road use mandate. If additional volumes are supplied to the market, this will be allocated in step 4 (all other volumes).
                                  </Typography>
                                  <br /><br />
                              </>
                          )}
                          {step === 4 && (
                              <>
                                  <Typography variant="h4">Allocation of volumes required by customers to be above the mandate</Typography>
                                  <Typography variant="body2" >
                                      In this step you will allocate the sustainability criteria for the volumes that customers have requested to be above the mandate levels. If there are additional volumes supplied to the market that is a surplus to the mandate levels, this will be allocated in step 6.
                                  </Typography>
                                  <br /><br />
                                  {reqByCustomerDisabled && (
                                      <Typography variant="h5">
                                          This step is disabled as no volume has been registered in the volumes section
                                      </Typography>
                                  )}
                              </>
                          )}
                          {step === 5 && (
                              <>
                                  <Typography variant="h4"> Allocation of volumes subject to joint fulfillment OUT</Typography>
                                  <Typography variant="body2">
                                      In this step you will allocate the sustainability criteria for the volumes that are subject to joint fulfillment OUT. This will be a part of the total volume above the mandate, including reserved volumes in step 4.
                                  </Typography>
                                  <br /><br />
                                  {outJointDisabled && (
                                      <Typography variant="h5">
                                          This step is disabled as no joint fulfillment OUT volume has been registered in the volumes section
                                      </Typography>
                                  )}
                              </>
                          )}
                          {step === 6 && (
                              <>
                                  <Typography variant="h4">Allocation of additional volumes above the mandate</Typography>
                                  <Typography variant="body2" >
                                      In this step you will allocate the sustainability criteria for all additional volumes above the mandate levels.
                                  </Typography>
                                  <br /><br />
                                  {aboveMandateAfterFulfillDisabled && (
                                      <Typography variant="h5">
                                          This step is disabled as there are no additional volumes above the mandate to allocate
                                      </Typography>
                                  )}
                              </>
                          )}
                      </Grid>
                      <Grid item style={{ flexShrink: 0 }}>
                        {step > 1 && (
                            <ButtonRounded
                                variant="outlined"
                                color="default"
                                className={classes.btn}
                                onClick={clickBack}

                            >
                                Back
                            </ButtonRounded>
                        )}
                        <ButtonRounded
                            variant="contained"
                            color="primary"
                            className={classes.btn}
                            onClick={clickNext}
                            disabled={step === 9 || isOverAllocated}
                        >
                            Next
                        </ButtonRounded>
                      </Grid>
                  </Grid>
                {step === 7 && (
                    <MatchingTables/>
                )}
                  {step === 8 && (
                      <RoadUseCustomerRequirements
                          onUpdateCustomerData={handleCustomerDataUpdate}
                          availableVol={availableVol}
                      />
                  )}
                  {step === 9 && (
                  <SuccessView text={"Allocation process is successful"} />
                  )}
                  {step !== 7 && step !== 8 && step !== 9 && (
                      <EditableTableContainer
                          reqByCustomerDisabled={reqByCustomerDisabled}
                          aboveMandateAfterFulfillDisabled={aboveMandateAfterFulfillDisabled}
                          outJointDisabled={outJointDisabled}
                          surplusStepDisabled={surplusStepDisabled}
                          updateIsFetching={updateIsFetching}
                          onUpdateData={handleTableDataUpdate}
                          onUpdateRequirement={handleRequirementDataUpdate}
                          stepTwoData={stepTwoData}
                          stepThreeData={stepThreeData}
                          stepFourData={stepFourData}
                          stepJointFulfData={stepJointFulfData}
                          stepFiveData={stepFiveData}
                          surplusBiotemplates={surplusBiotemplates}
                          activeStep={step} />
                  )}
      </CardContent>
    </Card>
  );
};

export default RoadUseCardEditableTable;
